export enum ErpTaskChannel {
  CREATE = 'erpTask::create',
  EDIT = 'erpTask::patch',
  DELETE = 'erpTask::delete',
}
